module.exports = __webpack_public_path__ + "static/favicon128-2371a586e16e8ccd57b40b8e7a0183af.ico";